import { render } from "./RadioGroupInline.vue?vue&type=template&id=2c70c2fe"
import script from "./RadioGroupInline.vue?vue&type=script&lang=js"
export * from "./RadioGroupInline.vue?vue&type=script&lang=js"

import exportComponent from "/trc/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__